module.exports = __webpack_public_path__ + "static/media/Brain_Lang.Proc.Lab.7059e7a3.jpeg";